"use client";

import { CommissionSummaryType, ContractType } from "@/openapi/generated";
import { formatAmount } from "@/lib/utils/currency";
import { AMAZON_SHOP_ID } from "@/lib/constants";
import { useTranslations } from "next-intl";

interface CommissionRangeSummary {
    max?: number;
    type?: CommissionSummaryType;
}

interface CommissionDisplayProps {
    commissionRangeSummary?: CommissionRangeSummary;
    contractType?: ContractType;
    className?: string;
    shopId?: string;
}

export function CommissionDisplay({ commissionRangeSummary, contractType, className, shopId }: CommissionDisplayProps) {
    const t = useTranslations("shops.commission");

    if (shopId === AMAZON_SHOP_ID) {
        return null;
    }

    if (!commissionRangeSummary || commissionRangeSummary.max === undefined || commissionRangeSummary.max <= 0) {
        if (contractType) {
            return (
                <div className={className} role="text">
                    {t("variableDonation")}
                </div>
            );
        }
        return null;
    }

    const isPercentage = commissionRangeSummary.type === CommissionSummaryType.PERCENTAGE;
    const formattedAmount = formatAmount(commissionRangeSummary.max);
    const unit = isPercentage ? t("unitPercent") : t("unitEuro");
    const displayText = t("upTo", { amount: formattedAmount, unit });
    const ariaLabel = t("ariaLabel", { amount: formattedAmount, unit });

    return (
        <div
            className={className}
            role="text"
            aria-label={ariaLabel}
        >
            {displayText}
        </div>
    );
}
